// Step 24 — Blocking / Requires Attention.
//
// Every row here has an actual backend source. We never claim "this
// prevents closing" — the wording is deterministic ("Kräver
// uppföljning", "Blockerad enligt systemstatus", "Över förfallodatum",
// "Kräver mänsklig granskning", "Osäkerhet registrerad").
//
// Links point at existing human-controlled surfaces.

import { Link } from "react-router-dom";

import { AIEmpty, AISection } from "../AIPrimitives";
import { executionBlockingItems } from "./helpers";

const _CATEGORY_LABEL = {
  action: "Åtgärd",
  contract: "Avtal",
  preparedness: "Beredskap",
};

function _link(item, workspaceId) {
  if (item.category === "action" && item.action_id != null) {
    return {
      to: `/deals/${workspaceId}/actions`,
      label: `Öppna åtgärd #${item.action_id} →`,
    };
  }
  if (item.category === "contract" && item.contract_id != null) {
    return {
      to: `/deals/${workspaceId}/contracts/${item.contract_id}`,
      label: `Öppna avtal #${item.contract_id} →`,
    };
  }
  return null;
}

export default function AIExecutionBlocking({
  actions,
  contracts,
  situation,
  workspaceId,
  now,
}) {
  const items = executionBlockingItems({ actions, contracts, situation, now });
  if (items.length === 0) {
    return (
      <AISection title="Blockerande & kräver uppföljning">
        <AIEmpty
          title="Inga blockerande eller försenade poster registrerade"
          hint={
            "Poster dyker upp här om DealActions blockeras, går över " +
            "förfallodatum, avtalsutkast väntar granskning, eller " +
            "beredskapsgap registreras i deal_situation."
          }
        />
      </AISection>
    );
  }

  return (
    <AISection
      title="Blockerande & kräver uppföljning"
      right={
        <span className="qai-page-section-hint">
          {items.length} post{items.length === 1 ? "" : "er"} · deterministisk data
        </span>
      }
    >
      <ul className="qai-execution-blocking">
        {items.map((it) => {
          const link = _link(it, workspaceId);
          return (
            <li
              key={it.key}
              className="qai-execution-blocking-row"
              data-severity={it.severity}
              data-category={it.category}
            >
              <div className="qai-execution-blocking-main">
                <div className="qai-execution-blocking-title">{it.title}</div>
                <div className="qai-execution-blocking-meta">
                  <span className="qai-execution-blocking-category">
                    {_CATEGORY_LABEL[it.category] || it.category}
                  </span>
                  <span> · </span>
                  <span className="qai-execution-blocking-reason">
                    {it.reason}
                  </span>
                  {it.source?.source_id && (
                    <>
                      <span> · </span>
                      <span className="qai-execution-blocking-source">
                        {it.source.source_type} #{it.source.source_id}
                      </span>
                    </>
                  )}
                </div>
              </div>
              {link && (
                <Link to={link.to} className="qai-page-section-link">
                  {link.label}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </AISection>
  );
}
